import { createAction, props } from '@ngrx/store';
import { SearchStrategyAction } from '../models/search-strategy-aciton.model';

export const updateJsonLogicBoolean = createAction('[Search Strategy Component] Update Json Logic Boolean', props<{ jsonLogic: any }>());

export const updateActionTypeOnSave = createAction(
  '[Search Strategy Component] Update Action Type On Save',
  props<{ action: SearchStrategyAction }>()
);

export const updateActionTypeOnModifyFilter = createAction(
  '[Add Filter Dialog Component] Update Action Type On Modify Filter',
  props<{ action: SearchStrategyAction }>()
);
